import { render, staticRenderFns } from "./procurement_notifications_dashboard.vue?vue&type=template&id=0071cfb8&scoped=true&"
import script from "./procurement_notifications_dashboard.vue?vue&type=script&lang=js&"
export * from "./procurement_notifications_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071cfb8",
  null
  
)

export default component.exports